<section class="login-page">
  <div class="login-card">
    <h1>BiodivScan Intranet</h1>
    <p class="subtitle">Connexion</p>

    <form (ngSubmit)="submit()" #loginForm="ngForm">
      <label for="username">Identifiant</label>
      <input
        id="username"
        name="username"
        type="text"
        required
        [(ngModel)]="username"
        autocomplete="username"
        [disabled]="loading"
      />

      <label for="password">Mot de passe</label>
      <input
        id="password"
        name="password"
        type="password"
        required
        [(ngModel)]="password"
        autocomplete="current-password"
        [disabled]="loading"
      />

      @if (newPasswordRequired) {
        <label for="newPassword">Nouveau mot de passe</label>
        <input
          id="newPassword"
          name="newPassword"
          type="password"
          required
          [(ngModel)]="newPassword"
          autocomplete="new-password"
          [disabled]="loading"
        />

        <label for="confirmNewPassword">Confirmer le nouveau mot de passe</label>
        <input
          id="confirmNewPassword"
          name="confirmNewPassword"
          type="password"
          required
          [(ngModel)]="confirmNewPassword"
          autocomplete="new-password"
          [disabled]="loading"
        />
      }

      @if (errorMessage) {
        <p class="error">{{ errorMessage }}</p>
      }

      <button type="submit" [disabled]="loginForm.invalid || loading">
        @if (loading) { Connexion… } @else if (newPasswordRequired) { Mettre a jour le mot de passe } @else { Se connecter }
      </button>
    </form>
  </div>
</section>
